import * as Sentry from '@sentry/react'

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0'),
    integrations: [Sentry.browserTracingIntegration()],
  })
}

export function setDisplayContext(placeId: string, userId: string): void {
  Sentry.setTag('place_id', placeId)
  Sentry.setTag('user_id', userId)
}
